import { fabric } from 'fabric';
import { CanvasDataTypes } from '../../../utils';
import { UneditedZoneTypeOfObjectEvent } from '../analytics-context-types';

const hasMissingText = (object?: fabric.Object) =>
  object?.data?.type === CanvasDataTypes.EditableText || object?.data?.type === CanvasDataTypes.PhotoTextZone;

const hasMissingImage = (object?: fabric.Object) =>
  object?.data?.type === CanvasDataTypes.PhotoZone || object?.data?.type === CanvasDataTypes.PhotoTextZone;

/**
 * Maps the unedited zones reported for a single card face to the analytics error taxonomy.
 * A photo text zone accepts either text or an image, so on its own it reports as "missing text/image".
 *
 * @param objects - The unedited zones reported for the face.
 *
 * @returns The `error` event for the face, or an empty event when no zone maps to the taxonomy.
 */
export const getUneditedZoneEvent = (...objects: (fabric.Object | undefined)[]): UneditedZoneTypeOfObjectEvent => {
  const isMissingText = objects.some(hasMissingText);
  const isMissingImage = objects.some(hasMissingImage);

  if (isMissingText && isMissingImage) {
    return { eventName: 'error', eventAction: 'missing text/image' };
  }
  if (isMissingText) {
    return { eventName: 'error', eventAction: 'missing text' };
  }
  if (isMissingImage) {
    return { eventName: 'error', eventAction: 'missing image' };
  }

  return { eventName: '', eventAction: '' };
};
